import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import { Table, AccountingTabsHeader, Button } from 'components';
import { Modal } from 'components/UI';
import { showApiError } from 'utils';
import { getPaymentsByMonthPerCreditReference } from 'services';
import { tableWrap, tableTabsButtonsWrap } from 'styles';
import { generatePaymentsByMonthPerCreditColumns } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";
var tableScrollWrapper = {
  overflowX: 'auto',
  width: '100%'
};

var PaymentsByMonthPerCreditReference = function PaymentsByMonthPerCreditReference() {
  var demoModalRef = useRef(null);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      columns = _useState2[0],
      setColumns = _useState2[1];

  var fetchPaymentsByMonthPerCreditReference = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getPaymentsByM, _yield$getPaymentsByM2, res, err, generatedColumns;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPaymentsByMonthPerCreditReference(tableOptions);

            case 2:
              _yield$getPaymentsByM = _context.sent;
              _yield$getPaymentsByM2 = _slicedToArray(_yield$getPaymentsByM, 2);
              res = _yield$getPaymentsByM2[0];
              err = _yield$getPaymentsByM2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              if (res !== null && res !== void 0 && res.data) {
                generatedColumns = generatePaymentsByMonthPerCreditColumns(res.data, res.months);
                setColumns(generatedColumns);
                res.data = res === null || res === void 0 ? void 0 : res.data.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    payments_by_month: Object.entries(item.payments_by_month).filter(function (_ref2) {
                      var _ref3 = _slicedToArray(_ref2, 2),
                          payment = _ref3[1];

                      var principal = parseFloat(payment.principal) || 0;
                      var interest = parseFloat(payment.interest) || 0;
                      var penalty = parseFloat(payment.penalty) || 0;
                      return principal > 0 || interest > 0 || penalty > 0;
                    }).reduce(function (acc, _ref4) {
                      var _ref5 = _slicedToArray(_ref4, 2),
                          month = _ref5[0],
                          payment = _ref5[1];

                      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, month, payment));
                    }, {})
                  });
                });
              }

              return _context.abrupt("return", [res, null]);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchPaymentsByMonthPerCreditReference(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Modal, {
    ref: demoModalRef
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"), ___EmotionJSX("p", {
    className: "mb1"
  }, "\u0411\u0438\u0445\u043C\u0435 \u0438\u0441\u043A\u0430\u043B\u0438 \u0434\u0430 \u0412\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u043C, \u0447\u0435 \u0442\u043E\u0432\u0430 \u0435 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430 \u0441\u0440\u0435\u0434\u0430, \u043F\u043E\u0440\u0430\u0434\u0438 \u043A\u043E\u0435\u0442\u043E \u0444\u0430\u0439\u043B\u043E\u0432\u0435\u0442\u0435 \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0441\u0432\u0430\u043B\u044F\u043D\u0438."), ___EmotionJSX("div", {
    css: function css(t) {
      return t.displayFlex({
        justify: 'flex-end'
      });
    }
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return demoModalRef.current.close();
    }
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"))), ___EmotionJSX("div", {
    css: tableTabsButtonsWrap
  }, ___EmotionJSX(Button, {
    small: true,
    type: "info",
    onClick: function onClick() {
      return demoModalRef.current.open();
    },
    leftIcon: {
      iconName: 'la la-file-excel',
      size: 20
    }
  }, "\u0415\u043A\u0441\u043F\u043E\u0440\u0442")), ___EmotionJSX(Table, {
    hasPagination: true,
    getDataMethod: fetchPaymentsByMonthPerCreditReference,
    columns: columns,
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: function filterBar(data) {
      return ___EmotionJSX(AccountingTabsHeader, data);
    },
    margin: "0 2em",
    css: tableScrollWrapper
  }));
};

export default PaymentsByMonthPerCreditReference;